import { h, Component } from 'preact';
import styles from './style';

import { getVideoURL } from '../../helper';
import { constants } from './../../config';

export default class VideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: 'vjs-user-active',
      play: null,
    };
    this.trackViewStatus = {};
  }

  componentWillMount() {
    this.setState({
      source: getVideoURL(this.props.item.url, typeof this.props.item.adunit_sizes !== 'undefined' ? this.props.item.adunit_sizes : this.props.item.sizes),
      currentTime: 0,
      elapsedTime: 0,
    })
  }

  componentDidMount() {
    let currentTime = Math.floor(this.getCurrentTime());
    this.bindEvents();
    this.setState({
      currentTime,
      elapsedTime: currentTime,
    });
  }

  componentWillUnmount() {
    this.setState({
      source: null,
      currentTime: 0,
      elapsedTime: 0,
    });

    this.unbindEvents();
  }

  render(props, state) {
    let customSeek = {
      width: `${this.getSeekValue()}%`,
      background: '#fff',
    };
    const playControlStyle = {
      backgroundColor: props.tag.details.color+'80' || 'transparent'
    }
    return (
      <div class={`vjs-wrap-module video-player-module video-js ${this.state.isActive}`} data-vjs-player key={this.props.item.url}>
        <video id={`video.${props.index}`}
               class={'videoplayer video-js'}
               autoplay={props.autoplay}
               poster={props.item.cover_image_selected}
               playsinline
               onClick={this.handleVideoClick}
               onFocus={this.handleVideoClick}
               ref={el => this.videoEl= el}
               src={this.state.source}
          muted={this.props.isMuted}
               type={`video/${props.item.extension}`} >
        </video>
        <div class={'custom-controls'}>
          <div class={'custom-seekbar'} ref={el => this.progressHolderEl = el} onClick={this.handleSeek}>
            <div class={'custom-seekbar-still'} />
            <div class={'custom-seekbar-progress'} style={customSeek} />
          </div>
        </div>

        { this.state.isActive && !this.props.hideControls ?
          <div onClick={this.handlePlayControlButtonClick} className={'wt-screen-playControl'} style={playControlStyle}>
            { this.state.isPlaying ? <i className={'zmdi zmdi-pause'} /> : <i className={'zmdi zmdi-play'} /> }
          </div> : null
        }

      </div>
    )
  }

  destroy = () => {
    console.log('destroy video player');
  }

  getSeekValue = () => {
    let duration = this.getDuration();
    let currentTime = this.getCurrentTime();

    if (!duration) return 0;
    else return currentTime/duration * 100;
  }

  handlePlayControlButtonClick = (e) => {
    if (this.videoEl.paused) {
      this.play();
      this.setState({ play: true });
      // this.props.handleVideoEvent();
    } else {
      this.pause();
      this.setState({ play: false });
    }
  }

  handleSeek = (e) => {
    let offsetX = e.offsetX;
    let seekWidth = e.target && e.target.offsetWidth;
    let pos = offsetX/seekWidth * 100;

    let duration = this.videoEl.duration;
    let seektime = pos/100 * duration;

    this.videoEl.currentTime = seektime;
  }

  handleVideoClick = (e) => {
    clearTimeout(this.activeTimer);

    if (this.state.isActive === 'vjs-user-active') {
      if (this.state.play !== null) {
        this.setState({
          isActive: 'vjs-user-inactive'
        });
      } else {
        this.videoEl.play();
      }
    } else {
      this.activeTimer = setTimeout(() => {
        this.setState({
          isActive: 'vjs-user-inactive'
        });
      }, 5000);

      this.setState({
        isActive: 'vjs-user-active'
      });
    }
  }

  handleTimeUpdate = () => {
    let currentTime = Math.floor(this.getCurrentTime())
    this.setState({
      currentTime,
      elapsedTime: currentTime,
    });

    if (this.lastRecordedDuration !== currentTime) {
      this.lastRecordedDuration = currentTime;
      if (currentTime % 5 === 0) {
        let video = this.state.source;
        let id = video.id;

        if (id) {
          this.props.logDataEvent({
            video_id: id,
            parent_video_id: this.props.videoId,
            type: 'view',
            subtype: null,
            event: 'view',
            current_duration: currentTime,
            duration: 5,
          });
        }
      }
    }

    /**
	 * Showcase video quartile event---
	 */
	const quartileEventNames = constants.QUARTILE_EVENT_TYPES;

	const videoDuration = Math.floor(this.getDuration());
	const currentQuarter = Math.floor(currentTime / (videoDuration / 4));

	if ( !this.trackViewStatus[currentQuarter] ){
	  this.trackViewStatus[currentQuarter] = true;
	  let video = this.state.source;
	  let id = video.id || 0; // Sending video_id as 0 by default---
	  this.props.eventBus(constants.LOG_EVENT_QUARTILE, {
		video_id: id,
		parent_video_id: this.props.videoId,
		tag: this.props.tag,
		type: 'showcase_quartile',
		event: 'showcase_quartile',
		current_duration: this.getCurrentTime(),
		event_type: quartileEventNames[currentQuarter],
    ...(this.props.eventData || {})
	  });
	}
  }

  handlePlayEvent = () => {
    this.setState({
      isPlaying: true
    }, () => {
      this.props.handleVideoEvent();
    });
  }

  handlePauseEvent = () => {
    this.setState({
      isPlaying: false
    })
  }

  play = () => {
    this.videoEl && this.videoEl.play();
  }

  pause = () => {
    this.videoEl && this.videoEl.pause();
  }

  getCurrentTime = () => {
    if (this.videoEl) {
      return this.videoEl.currentTime;
    } else return 0;
  }

  setCurrentTime = (num=0) => {
    if (this.videoEl) {
      this.videoEl.currentTime = num;
    }
  }

  getDuration = () => {
    if (this.videoEl) {
      return this.videoEl.duration;
    } else return 0;
  }

  bindEvents() {
    this.videoEl.addEventListener('timeupdate', this.handleTimeUpdate);
    this.videoEl.addEventListener('play', this.handlePlayEvent);
    this.videoEl.addEventListener('pause', this.handlePauseEvent);
  }

  unbindEvents() {
    this.videoEl.removeEventListener('timeupdate', this.handleTimeUpdate);
    this.videoEl.removeEventListener('play', this.handlePlayEvent);
    this.videoEl.removeEventListener('pause', this.handlePauseEvent);
  }
}



// WEBPACK FOOTER //
// ./components/spareparts/videoplayer/index.js